const TableState = require('../model/TableState');
const DEFAULT_SEARCH_KEY = 'name',
    ARRAYBUFFER_TYPE = 'arraybuffer';

const SERVER_API = 'api/v1/';

class RestService {
    constructor(config, $http, $state, $q, $log, $localStorage, $timeout, storageService, principalService, notificationService) {
        this.config = config;
        this._$http = $http;
        this._$state = $state;
        this._$q = $q;
        this.$log = $log;
        this.$localStorage = $localStorage;
        this.$timeout = $timeout;
        this.storageService = storageService;
        this.principalService = principalService;
        this.notificationService = notificationService;
        this.serverUrl = this.storageService.getManagerHostname();
    }

    useJsonServer() {
        this.serverUrl = this.config.jsonServerUrl;
    }

    getById(request, id, skipTokenUpdate) {
        return this.get(request + '/' + encodeURI(id), false, false, skipTokenUpdate)
    }

    getByIdFilter(request, id) {
        return this.get(request + '?filter=uuid%3D%3D' + encodeURI(id), false)
    }

    get(request, log, arraybuffer = false, skipTokenUpdate, params, withoutsubscriptionId, absolute, withoutProtectionSetId, token, headersProps) {
        this.serverUrl = this.storageService.getManagerHostname();
        if (withoutsubscriptionId || this.storageService.getSubscription()) {
            if (!token) { this.principalService.checkLogout(); }
            if (!skipTokenUpdate) {
                this.principalService.updateTokenFn();
            }
            let url;
            let reqToken = token ? token : this.storageService.getToken()

            if (absolute) {
                url = request;
            } else {
                url = withoutsubscriptionId
                    ? this.serverUrl + SERVER_API
                    : this.serverUrl + SERVER_API + `subscriptions/${this.storageService.getSubscription().uuid}/`;

                url = withoutProtectionSetId
                    ? url + request
                    : url + `protectionSets/${this.storageService.getProtectionSet().uuid}/` + request;
            }

            let req = {
                method: 'GET',
                url: url,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + reqToken,
                    'If-Modified-Since': '0'
                }
            };
            if (log) this.$log.info(req);
            if (arraybuffer) req.responseType = ARRAYBUFFER_TYPE;
            if (params) req.params = params;
            if (headersProps) {
                for (let prop in headersProps) {
                    if (headersProps[prop]) req.headers[prop] = headersProps[prop];
                }
            }
            return this.handleResponse(req);
        }
        else {
            return this.$timeout(() => {
                return this.get(request, log, arraybuffer, skipTokenUpdate, params, withoutsubscriptionId);
            }, 1000);
        }
    }

    getPaged(request, tableState, searchKey, filterKey, filterVal, pageSize, withoutsubscriptionId, absolute, withoutProtectionSetId) {
        return this.get(request + this.getPagedQuery(tableState, searchKey, filterKey, filterVal, pageSize), null, null, null, null, withoutsubscriptionId, absolute, withoutProtectionSetId);
    }

    getPagedQuery(tableState, searchKey, filterKey, filterVal, pageSize) {
        tableState = tableState || new TableState();
        if (pageSize) tableState.pageSize = pageSize;
        return `?pageSize=${tableState.pageSize}` +
            `&pageNumber=${tableState.page}` +
            (tableState.orderBy ? `&orderBy=${encodeURI(tableState.orderBy)}` : '') +
            this.getSearchQuery(searchKey, tableState.searchBy) +
            this.getFilterQuery(filterKey, filterVal);
    }

    getSearchQuery(searchKey, searchVal) {
        let result = '';
        if (searchVal) {
            if (Array.isArray(searchKey)) {
                searchKey.forEach((val) => {
                    result += '&filter=' + encodeURI(val || DEFAULT_SEARCH_KEY) + encodeURIComponent(TableState.getSearchOp()) + encodeURIComponent(searchVal);
                });
            }
            else {
                result += '&filter=' + encodeURI(searchKey || DEFAULT_SEARCH_KEY) + encodeURIComponent(TableState.getSearchOp()) + encodeURIComponent(searchVal);
            }
        }
        return result;
    }

    getFilterQuery(filterKey, filterVal) {
        return (filterKey && filterVal) ?
            '&filter=' +
            encodeURI(filterKey) +
            encodeURIComponent(TableState.getFilterOp()) +
            encodeURI(filterVal)
            : '';
    }


    getPagedWithStructuredFilter(request, tableState, filters, force, searchKey, withoutProtId, headersProps) {
        return this.get(request + this.getPagedQueryWithStructuredFilter(tableState, filters, force, searchKey), null, null, null, null, null, null, withoutProtId, null, headersProps);
    }

    getPagedQueryWithStructuredFilter(tableState, filters, forceSync, searchKey) {
        tableState = tableState || new TableState();
        let force = forceSync ? '&forceSync=true' : '';
        return `?pageSize=${tableState.pageSize}` +
            `&pageNumber=${tableState.page}` + force +
            (tableState.orderBy ? `&orderBy=${encodeURI(tableState.orderBy)}` : '') +
            (filters ? this.getStructuredFilterQuery(filters) : '') +
            this.getSearchQuery(searchKey, tableState.searchBy);
    }

    getStructuredFilterQuery(filters) {
        let result = '';
        filters.forEach((filter) => {
            if (filter.filterBy) {
                if (filter.type === 'search') {
                    result += (filter.findByUuid ?
                        ('&filter=uuid%3D%3D' + encodeURI(filter.filterBy)) :
                        ('&filter=' + encodeURI(filter.filterKey) + encodeURIComponent(TableState.getSearchOp()) + (filter.filterByEncode ? filter.filterByEncode : encodeURIComponent(filter.filterBy))));
                    if (!filter.findByUuid && filter.additionalSearch && filter.additionalSearch.length) {
                        filter.additionalSearch.forEach(key => result += ('&filter=' + encodeURI(key) + encodeURIComponent(TableState.getSearchOp()) + (filter.filterByEncode ? filter.filterByEncode : encodeURI(filter.filterBy))))
                    }

                } else if (filter.type === 'time') {
                    filter.filterBy.forEach((val) => {
                        result += '&filter=' + encodeURI(filter.filterKey) + encodeURIComponent(val.option) + encodeURIComponent(val.value)
                    });
                } else {
                    result += '&filter=' + encodeURI(filter.filterKey) + encodeURIComponent(TableState.getFilterOp()) + (filter.filterByEncode ? filter.filterByEncode : encodeURI(filter.filterBy));
                }
            }
        });
        return result;
    }

    put(request, data, log, withoutsubscriptionId, absolute, withoutProtectionSetId) {
        this.principalService.checkLogout();
        this.principalService.updateTokenFn();
        this.serverUrl = this.storageService.getManagerHostname();

        let url;

        if (absolute) {
            url = request;
        } else {
            url = withoutsubscriptionId
                ? this.serverUrl + SERVER_API
                : this.serverUrl + SERVER_API + `subscriptions/${this.storageService.getSubscription().uuid}/`;

            url = withoutProtectionSetId
                ? url + request
                : url + `protectionSets/${this.storageService.getProtectionSet().uuid}/` + request;
        }

        let req = {
            method: 'PUT',
            url: url,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.storageService.getToken()
            }
        };

        if (data) req.data = data;
        if (log) this.$log.info(req);

        return this.handleResponse(req);
    }

    patch(request, data, log, withoutsubscriptionId, withoutProtectionSetId, absolute) {
        this.principalService.checkLogout();
        this.principalService.updateTokenFn();
        this.serverUrl = this.storageService.getManagerHostname();

        let url;

        if (absolute) {
            url = request;
        } else {
            url = withoutsubscriptionId
                ? this.serverUrl + SERVER_API
                : this.serverUrl + SERVER_API + `subscriptions/${this.storageService.getSubscription().uuid}/`;

            url = withoutProtectionSetId
                ? url + request
                : url + `protectionSets/${this.storageService.getProtectionSet().uuid}/` + request;
        }

        let req = {
            method: 'PATCH',
            url: url,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.storageService.getToken()
            }
        };

        if (data) req.data = data;
        if (log) this.$log.info(req);

        return this.handleResponse(req);
    }

    post(request, data, log, withoutsubscriptionId, contentType, withoutProtectionSetId, absolute) {
        this.principalService.checkLogout();
        this.principalService.updateTokenFn();
        this.serverUrl = this.storageService.getManagerHostname();

        let url;

        if (absolute) {
            url = request;
        } else {
            url = withoutsubscriptionId
                ? this.serverUrl + SERVER_API
                : this.serverUrl + SERVER_API + `subscriptions/${this.storageService.getSubscription().uuid}/`;

            url = withoutProtectionSetId
                ? url + request
                : url + `protectionSets/${this.storageService.getProtectionSet().uuid}/` + request;
        }

        let req = {
            method: 'POST',
            url: url,
            headers: {
                'Content-Type': contentType || 'application/json',
                'Authorization': 'Bearer ' + this.storageService.getToken()
            }
        };
        if (data) req.data = data;
        if (log) this.$log.info(req);
        return this.handleResponse(req);
    }


    del(request, uuid, log, skipTokenUpdate, withoutsubscriptionId, withoutProtectionSetId, absolute) {
        this.principalService.checkLogout();
        this.serverUrl = this.storageService.getManagerHostname();

        // added for handling custom SSE reconnection
        if (!skipTokenUpdate) this.principalService.updateTokenFn();

        let url;

        if (absolute) {
            url = request;
        } else {
            url = withoutsubscriptionId
                ? this.serverUrl + SERVER_API
                : this.serverUrl + SERVER_API + `subscriptions/${this.storageService.getSubscription().uuid}/`;

            url = withoutProtectionSetId
                ? url + request
                : url + `protectionSets/${this.storageService.getProtectionSet().uuid}/` + request;
        }

        let req = {
            method: 'DELETE',
            url: url,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.storageService.getToken()
            }
        };

        if (uuid) req.url = req.url + '/' + uuid;
        if (log) this.$log.info(req);

        return this.handleResponse(req);
    }

    exportFilePdf(request, log, arraybuffer = true, skipTokenUpdate, params) {
        this.principalService.checkLogout();
        if (!skipTokenUpdate) {
            this.principalService.updateTokenFn();
        }
        this.serverUrl = this.storageService.getManagerHostname();
        let req = {
            method: 'GET',
            url: this.serverUrl + SERVER_API + `subscriptions/${this.storageService.getSubscription().uuid}/protectionSets/${this.storageService.getProtectionSet().uuid}/` + request,
            headers: {
                'Content-Type': undefined,
                'Authorization': 'Bearer ' + this.storageService.getToken()
            }
        };
        if (log) this.$log.info(req);
        if (arraybuffer) req.responseType = ARRAYBUFFER_TYPE;
        if (params) req.params = params;
        return this.handleResponse(req);
    }

    delSpecifySubscription(request, expiredToken, subscriptionId, isLogout) {
        let req = {
            method: 'DELETE',
            url: this.serverUrl + SERVER_API + `subscriptions/${subscriptionId}/` + request,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + (expiredToken ? expiredToken : this.storageService.getToken()),
                'isLogout': angular.isDefined(isLogout) ? isLogout : undefined
            }
        };
        return this.handleResponse(req);
    }

    uploadFile(method, request, data, log) {
        this.principalService.checkLogout();
        this.principalService.updateTokenFn();
        let req = {
            method: method,
            url: this.serverUrl + SERVER_API + request,
            transformRequest: angular.identity,
            headers: {
                'Content-Type': undefined,
                'Authorization': 'Bearer ' + this.storageService.getToken()
            }
        };
        if (data) req.data = data;
        if (log) this.$log.info(req);
        return this.handleResponse(req);
    }

    handleResponse(req) {
        return this._$q((resolve, reject) => this._$http(req).then(resp => {
            if (resp.data) {
                resp.data.tableState = resp.data.metadata && resp.data.metadata !== null ? TableState.fromRaw(resp.data.metadata) : null;
            }
            resolve(resp);
        }, err => reject(this.handleError(err, req.responseType === ARRAYBUFFER_TYPE))
        ));
    }

    handleError(err, decodingNeeded) {
        if (!err) return;
        if (decodingNeeded) {
            err.data = this.decodeErrorData(err.data);
        }
        switch (err.status) {
            case 401:
                this.principalService.forceLogout(true);
                this._$state.go('login');
                break;
            case 404:
                err.messageClass = 'alert-danger';
                err.notifType = 'error';
                if (err.data && err.data.message) this.notificationService.pop(err.data.message);
                break;
            // case -1:
            case 400:
            case 500:
                if (!err.data || !err.data.message) {
                    err.message = err.message || err.statusText;
                    err.messageClass = 'alert-danger';
                    err.notifType = 'error'
                } else {
                    this.notificationService.pop(err.data.message);
                }
                break;
            default:
                if (err.data && err.data.message) this.notificationService.pop(err.data.message);
                break;
        }
        return err;
    }

    decodeErrorData(data) {
        if (!data) return;
        let response;
        if ('TextDecoder' in window) {
            // Decode as UTF-8
            let dataView = new DataView(data),
                decoder = new TextDecoder('utf8');
            response = JSON.parse(decoder.decode(dataView));
        } else {
            // Fallback decode as ASCII
            let decodedString = String.fromCharCode.apply(null, new Uint8Array(data));
            response = JSON.parse(decodedString);
        }
        return response;
    }
}

RestService.$inject = ['config', '$http', '$state', '$q', '$log', '$localStorage', '$timeout', 'storageService', 'principalService', 'notificationService'];

module.exports = RestService;



// WEBPACK FOOTER //
// ./src/azurebackup/services/crud.service.js